import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { UserService } from "@teammood/shared/util/user";
import { Mood } from "@teammood/timeline";
import { Router } from "@angular/router";

@Component({
    selector: 'choose-mood',
    templateUrl: './choose-mood.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChooseMoodComponent implements OnInit, OnDestroy {

    protected mood: Mood = new Mood();

    private _destroy$ = new Subject<void>();

    constructor(
        private userService: UserService,
        private router: Router,
    ) {}
    
    ngOnInit() {
        this.userService.get().then((user) => {
           this.mood.teamId = user.teamId;
        });
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    async next () {
        if (this.mood.id){
            await this.router.navigate(['add_other_feedback', this.mood.id]);
        }
    }

    protected onMoodUpdated(mood: Mood) {
        this.mood = mood;
    }
}